/***** FLOWS *****/
export const SWITCH_VIEW = "SWITCH_VIEW";
export const OPEN_NEW_FLOW_DIALOG = "OPEN_NEW_FLOW_DIALOG";
export const CLOSE_NEW_FLOW_DIALOG = "CLOSE_NEW_FLOW_DIALOG";
export const CREATE_NEW_FLOW_FROM_PORTAL = "CREATE_NEW_FLOW_FROM_PORTAL";
export const FETCH_PORTAL_FLOWS = "FETCH_PORTAL_FLOWS";
export const SET_IS_LOADING_PORTAL_FLOWS = "SET_IS_LOADING_PORTAL_FLOWS";
export const ADD_PORTAL_FLOW = "ADD_PORTAL_FLOW";
export const ARE_FLOWS_LOADED = "ARE_FLOWS_LOADED";
export const SET_OWNED_SHARED_FLOWS = "SET_OWNED_SHARED_FLOWS";
export const FETCH_WORKFLOW_ACTIVITIES = "FETCH_WORKFLOW_ACTIVITIES";
export const FETCH_ANALYTICS_ACTIVITIES = "FETCH_ANALYTICS_ACTIVITIES";
export const SET_WORKFLOW_ACTIVITIES = "SET_WORKFLOW_ACTIVITIES";
export const SET_ANALYTICS_ACTIVITIES = "SET_ANALYTICS_ACTIVITIES";
export const SHARE_PORTAL_FLOW = "SHARE_PORTAL_FLOW";
export const FETCH_PORTAL_USER_FLOWS = "FETCH_PORTAL_USER_FLOWS";
export const SET_PORTAL_USER_FLOWS = "SET_PORTAL_USER_FLOWS";
export const UPSERT_PORTAL_USER_FLOWS = "UPSERT_PORTAL_USER_FLOWS";
export const REMOVE_PORTAL_USER_FLOWS = "REMOVE_PORTAL_USER_FLOWS";
export const SET_PORTAL_FLOWS = "SET_PORTAL_FLOWS";
export const UPDATE_PORTAL_FLOW = "UPDATE_PORTAL_FLOW";

/***** SETTINGS *****/
export const SET_THEME_MODE = "SET_THEME_MODE";
export const SET_IS_SYSTEM_THEME = "SET_IS_SYSTEM_THEME";
export const SET_IS_LOGOUT = "SET_IS_LOGOUT";
export const SET_COMPANY_LOGO = "SET_COMPANY_LOGO";

/***** USERS *****/
export const FETCH_USERS = "FETCH_USERS";
export const SET_USERS = "SET_USERS";
export const SET_IS_LOADING_USERS = "SET_IS_LOADING_USERS";
export const FETCH_USER = "FETCH_USER";
export const SET_USER = "SET_USER";
export const SET_IS_LOADING_USER = "SET_IS_LOADING_USER";
export const SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const UPDATE_USER = "UPDATE_USER";
export const SWITCH_USER_VIEW = "SWITCH_USER_VIEW";

/***** LOGS *****/
export const SET_IS_LOADING_LOGS = "SET_IS_LOADING_LOGS";
export const SET_NO_RESULT_FOUND = "SET_NO_RESULT_FOUND";

/***** ROLES *****/
export const FETCH_ROLES = "FETCH_ROLES";
export const SET_ROLES = "SET_ROLES";

/***** UDAS SOCKET *****/
export const SET_UDAS_SOCKET = "SET_UDAS_SOCKET";

/***** SUBSCRIPTIONS *****/
export const FETCH_TENANT_SUBSCRIPTION = "FETCH_TENANT_SUBSCRIPTION";
export const SET_TENANT_SUBSCRIPTION = "SET_TENANT_SUBSCRIPTION";
export const FETCH_CUSTOMER_SUBSCRIPTION = "FETCH_CUSTOMER_SUBSCRIPTION";
export const SET_CUSTOMER_SUBSCRIPTION = "SET_CUSTOMER_SUBSCRIPTION";
export const SET_CUSTOMER_SUBSCRIPTION_IS_LOADING = "SET_CUSTOMER_SUBSCRIPTION_IS_LOADING";
export const SET_CUSTOMER_SUBSCRIPTION_DONE_FETCHING = "SET_CUSTOMER_SUBSCRIPTION_DONE_FETCHING";
export const FETCH_STRIPE_CUSTOMER_DETAILS = "FETCH_STRIPE_CUSTOMER_DETAILS";
export const SET_STRIPE_CUSTOMER_DETAILS = "SET_STRIPE_CUSTOMER_DETAILS";
export const FETCH_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS =
  "FETCH_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS";
export const SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS =
  "SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS";
export const SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING = "SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING";
export const SET_SELECTED_SUBSCRIPTION = "SET_SELECTED_SUBSCRIPTION";
export const SET_SUBSCRIPTION_IS_LOADING = "SET_SUBSCRIPTION_IS_LOADING";

/***** CUSTOMER BILLING *****/
export const SET_ADD_CARD_FORM_IS_LOADING = "SET_ADD_CARD_FORM_IS_LOADING";
export const SET_IS_LOADING_PAYMENT_METHODS = "SET_IS_LOADING_PAYMENT_METHODS";
export const FETCH_PAYMENT_METHODS = "FETCH_PAYMENT_METHODS";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
export const ADD_CARD_FORM_IS_SUBMITTING = "ADD_CARD_FORM_IS_SUBMITTING";

/***** CREDENTIAL MANANGEMENT *****/
export const OPEN_CREDENTIAL_DIALOG = "OPEN_CREDENTIAL_DIALOG";
export const CLOSE_CREDENTIAL_DIALOG = "CLOSE_CREDENTIAL_DIALOG";
export const FETCH_CREDENTIALS = "FETCH_CREDENTIALS";
export const SET_CREDENTIALS = "SET_CREDENTIALS";
export const SET_IS_LOADING_CREDENTIALS = "SET_IS_LOADING_CREDENTIALS";
export const SET_CREDENTIAL_DIALOG_MODE = "SET_CREDENTIAL_DIALOG_MODE";
export const SET_DELETE_CREDENTIAL_DIALOG_OPEN = "SET_DELETE_CREDENTIAL_DIALOG_OPEN";
export const SET_CREDENTIAL_MANAGEMENT_FILTER = "SET_CREDENTIAL_MANAGEMENT_FILTER";
export const SET_CREDENTIAL_MANAGEMENT_SHARE_USERS_MODAL_OPEN =
  "SET_CREDENTIAL_MANAGEMENT_SHARE_USERS_MODAL_OPEN";
export const SET_CREDENTIAL_MANAGEMENT_UNSHARE_USERS_MODAL_OPEN =
  "SET_CREDENTIAL_MANAGEMENT_UNSHARE_USERS_MODAL_OPEN";
export const SET_CREDENTIAL_MANAGEMENT_SHARE_AVAILABLE_USERS =
  "SET_CREDENTIAL_MANAGEMENT_SHARE_AVAILABLE_USERS";
export const SET_CREDENTIAL_MANAGEMENT_UNSHARE_AVAILABLE_USERS =
  "SET_CREDENTIAL_MANAGEMENT_UNSHARE_AVAILABLE_USERS";
export const SET_CREDENTIAL_MANAGEMENT_SHARE_SELECTED_USERS =
  "SET_CREDENTIAL_MANAGEMENT_SHARE_SELECTED_USERS";
export const CLEAR_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USERS =
  "CLEAR_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USERS";
export const ADD_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER =
  "ADD_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER";
export const REMOVE_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER =
  "REMOVE_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER";
export const SET_CREDENTIAL_MANAGEMENT_UNSHARE_SELECTED_USERS =
  "SET_CREDENTIAL_MANAGEMENT_UNSHARE_SELECTED_USERS";
export const SET_SELECTED_CREDENTIAL = "SET_SELECTED_CREDENTIAL";
export const SHARE_CREDENTIALS = "SHARE_CREDENTIALS";
export const OPEN_SHARER_FLOW_DIALOG = "OPEN_SHARER_FLOW_DIALOG";
export const CLOSE_SHARER_FLOW_DIALOG = "CLOSE_SHARER_FLOW_DIALOG";
export const OPEN_SHAREE_FLOW_DIALOG = "OPEN_SHAREE_FLOW_DIALOG";
export const CLOSE_SHAREE_FLOW_DIALOG = "CLOSE_SHAREE_FLOW_DIALOG";
export const SET_CREDENTIALS_IN_SHARED_FLOW = "SET_CREDENTIALS_IN_SHARED_FLOW";

/***** Integrations *****/
export const OPEN_NEW_INTEGRATION_DIALOG = "OPEN_NEW_INTEGRATION_DIALOG";
export const CLOSE_NEW_INTEGRATION_DIALOG = "CLOSE_NEW_INTEGRATION_DIALOG";
export const SET_INTEGRATION_MUTATING_FLAG = "SET_INTEGRATION_MUTATING_FLAG";
export const CREATE_NEW_INTEGRATION = "CREATE_NEW_INTEGRATION";
export const SET_INTEGRATIONS = "SET_INTEGRATIONS";
export const FETCH_INTEGRATIONS = "FETCH_INTEGRATIONS";
export const ADD_INTEGRATION = "ADD_INTEGRATION";
export const DELETE_INTEGRATION = "DELETE_INTEGRATION";
export const REMOVE_DELETED_INTEGRATION = "REMOVE_DELETED_INTEGRATION";
export const UPDATE_INTEGRATION = "UPDATE_INTEGRATION";
export const UPDATE_UPDATED_INTEGRATION = "UPDATE_UPDATED_INTEGRATION";
export const SET_OPEN_SHARE_INTEGRATION_DIALOG = "SET_OPEN_SHARE_INTEGRATION_DIALOG";
export const SET_OPEN_UNSHARE_INTEGRATION_DIALOG = "SET_OPEN_UNSHARE_INTEGRATION_DIALOG";
export const SET_OPEN_SHARE_UNSHARE_DIALOG = "SET_OPEN_SHARE_UNSHARE_DIALOG";
export const FETCH_OWNED_SHARED_INTEGRATIONS = "FETCH_OWNED_SHARED_INTEGRATIONS";
export const SET_OWNED_SHARED_INTEGRATIONS = "SET_OWNED_SHARED_INTEGRATIONS";
export const FETCH_SHARED_INTEGRATIONS_SHARED = "FETCH_SHARED_INTEGRATIONS_SHARED";
export const SET_SHARED_INTEGRATIONS_SHARED = "SET_SHARED_INTEGRATIONS_SHARED";
export const FETCH_SHARED_INTEGRATIONS = "FETCH_SHARED_INTEGRATIONS";
export const SET_SHARED_INTEGRATIONS = "SET_SHARED_INTEGRATIONS";
export const UPDATE_SHARED_INTEGRATION = "UPDATE_SHARED_INTEGRATION";

/***** Resource Dependencies *****/
export const CREATE_RESOURCE_DEPENDENCY = "CREATE_RESOURCE_DEPENDENCY";
export const CREATE_RESOURCE_DEPENDENCIES = "CREATE_RESOURCE_DEPENDENCIES";
export const DELETE_RESOURCE_DEPENDENCY = "DELETE_RESOURCE_DEPENDENCY";
export const DELETE_RESOURCE_DEPENDENCIES = "DELETE_RESOURCE_DEPENDENCIES";
export const UPDATE_RESOURCE_DEPENDENCY = "UPDATE_RESOURCE_DEPENDENCY";
export const SYNC_FLOW_INTEGRATION_DEPENDENCIES =
  "SYNC_FLOW_INTEGRATION_DEPENDENCIES";

/***** AUTH *****/
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_SUCCESS_RESET = "USER_LOGOUT_SUCCESS_RESET";
export const SET_SUSPENDED_USER_FLAG = "SET_SUSPENDED_USER_FLAG";

/***** Products *****/
export const SET_PRODUCTS = "SET_PRODUCTS";

/***** Sharing *****/
export const SET_EXTERNAL_USERS_SHARE_DIALOG_OPEN = "SET_EXTERNAL_USERS_SHARE_DIALOG_OPEN";
export const SET_SHARE_ITEM_DATA = "SET_SHARE_ITEM_DATA";

/***** Connectors *****/
export const SET_OWNED_CONNECTORS = "SET_OWNED_CONNECTORS";
export const SET_PURCHASED_CONNECTORS = "SET_PURCHASED_CONNECTORS";
export const SET_SHARED_CONNECTORS = "SET_SHARED_CONNECTORS";
export const ADD_SHARED_CONNECTORS = "ADD_SHARED_CONNECTORS";
export const GET_SHARED_CONNECTORS = "GET_SHARED_CONNECTORS";
export const REMOVE_SHARED_CONNECTORS = "REMOVE_SHARED_CONNECTORS";
export const UPDATE_SHARED_CONNECTOR = "UPDATE_SHARED_CONNECTOR";
